<template>
  <v-card class="mb-12 pa-10" color="secondaryBackground" min-height="200px">
    <v-container fluid>
      <v-row
        @click="handleClick"
        v-for="agreement in agreements"
        :key="agreement.id"
      >
        <v-col cols="auto">
          <v-checkbox hide-details v-model="agreement.checked">
            <template v-slot:label>
              <div class="checkbox-label" v-html="agreement.text" @click.stop="handleClick" />
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
export default {
  methods: {
    handleClick(e) {
      if (e.target.matches(".checkbox-label a")) {
        e.stopPropagation();
      }
    },
  },
  props: {
    published: Boolean,
  },
  data() {
    return {
      agreements: [
        {
          text: this.$t("storyHub.publishing.iOwnCopyright"),
          id: "iOwnCopyright",
          checked: this.published,
        },
        {
          text: this.$t("storyHub.publishing.readUserAgreement", {
            escapeInterpolation: false,
            agreementLink: "/eula",
          }),
          id: "readUserAgreement",
          checked: this.false,
        },
        {
          text: this.$t("storyHub.publishing.havePlaytested"),
          id: "havePlaytested",
          checked: this.false,
        },
        {
          text: this.$t(
            "storyHub.publishing.notSendingPeopleToDangerousPlaces"
          ),
          id: "notSendingPeopleToDangerousPlaces",
          checked: this.false,
        },
      ],
    };
  },
  watch: {
    publishable(newValue) {
      this.$emit('input', newValue)
    }
  },
  computed: {
    publishable() {
      let publishable = true
      for (const agreement of this.agreements) {
        if (!agreement.checked) {
          publishable = false;
        }
      }
      return publishable; 
    }
  },
};
</script>